<template>
  <div>
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="compass"></a-icon>
          <span>网络拓扑</span>
        </a-space>
      </template>
      <span>网络拓扑包含网络设备和网口。</span>
    </a-page-header>

    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout
        :getTableDataFunc="getTableDataFunc"
        :columnDefaultSelected="columnDefaultSelected"
        :columnsAll="columnsAll"
        :toolsList="['setting', 'reload', 'search', 'leftTool']"
        :refresh="refresh"
        :defaultSelected="tableSelectData"
        :table-operation-width="240"
        @tableSelectData="(v) => tableSelectData = v"
      >
        <!-- 工具栏 -->
        <template #leftTool>
          <create-button
            v-permission="{action: 'base.network_topology.create', effect: 'disabled'}"
            @click="$refs.inputDrawer.show()"
          >
          </create-button>
        </template>
        <!-- 表格自定义列 -->
        <template #name="{ slotProps }">
          <a-tooltip placement="topLeft" :title="slotProps.record.name">
            <a
              v-if="slotProps.record.completed"
              @click="$refs.detailDrawer.show(slotProps.record.id)"
            >
              {{ slotProps.text }}
            </a>
            <span v-else>{{ slotProps.text }}</span>
          </a-tooltip>
        </template>
        <template #completed="{ slotProps }">
          <boolean-tag
            false-color="#1890ff"
            false-name="生成中"
            true-name="已生成"
            :value="slotProps.text"
          ></boolean-tag>
        </template>
        <template #operation="{ slotProps }">
          <edit-button
          v-permission="{action: 'base.network_topology.update', effect: 'disabled'}"
            @click="$refs.inputDrawer.show(slotProps.record.id)"
          ></edit-button>
          <topology-button
          v-permission="{action: 'base.network_topology.update', effect: 'disabled'}"
            @click="{
              if(slotProps.record.completed)
              $router.push({ name: 'NetworkTopologyDetail', params: { id: slotProps.record.id } })
            }"
          ></topology-button>
          <delete-button
          v-permission="{action: 'base.network_topology.delete', effect: 'disabled'}"
            @confirm="confirm(slotProps.record.id)"
          ></delete-button>
        </template>
      </list-layout>
    </a-card>

    <detail-drawer ref="detailDrawer"></detail-drawer>
    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
  </div>
</template>

<script>
import {
  getNetworkTopologyList,
  deleteNetworkTopology
} from '@/api/network-topology'
import ListLayout from '@/components/ListLayout'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'
import CreateButton from '@/components/button/CreateButton'
import TopologyButton from '@/components/button/TopologyButton'
import BooleanTag from '@/components/tag/BooleanTag'
import DetailDrawer from './modules/DetailDrawer'
import InputDrawer from './modules/InputDrawer'

export default {
  name: 'NetworkTopology',
  components: {
    BooleanTag,
    DeleteButton,
    DetailDrawer,
    EditButton,
    InputDrawer,
    CreateButton,
    ListLayout,
    TopologyButton
  },
  data () {
    return {
      getTableDataFunc: getNetworkTopologyList,
      columnsAll: [
        {
          dataIndex: 'name',
          title: '网络拓扑名称',
          fixed: 'left',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'description',
          title: '描述',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'description'
          }
        },
        {
          dataIndex: 'created_at',
          title: '创建时间',
          width: 200
        },
        {
          dataIndex: 'updated_at',
          title: '更新时间',
          width: 200
        },
        {
          dataIndex: 'completed',
          title: '状态',
          width: 100,
          scopedSlots: {
            customRender: 'completed'
          },
          filters: [
            {
              text: '已生成',
              value: 'true'
            },
            {
              text: '生成中',
              value: 'false'
            }
          ],
          filterMultiple: false
        }
      ],
      columnDefaultSelected: [
        'name',
        'description',
        'updated_at',
        'completed'],
      refresh: false,
      tableSelectData: []
    }
  },
  methods: {
    async confirm (id = '') {
      if (id) {
        await deleteNetworkTopology(id).then(res => {
          this.$message.success(res.message)
        })
        this.tableSelectData.splice(this.tableSelectData.findIndex(item => item.key === id), 1)
      }
      this.refresh = !this.refresh
    }
  }
}
</script>
